import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router";
import { imgclothes } from "../../../assets/activityes/topiconeActivityone";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { DialogBarCharacterDress } from "../../../components/common/DialogBarCharacterDress";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const dialogues = {
	dialogOne: `¡Muy bien! Comenzaremos con nuestra primera actividad: "Código de vestimenta".`,
	dialogTwo: "Selecciona la vestimenta que consideres adecuada.",
};

const steps = {
	initialDialog: 1,
	instructions: 2,
	instructionsDialog: 3,
	game: 4,
	win: 5,
	fail: 6,
};

const clothes = {
	shirt: [
		{
			id: 1,
			img: imgclothes.male_shirt,
		},
		{
			id: 2,
			img: imgclothes.male_blue_shirt,
		},
		{
			id: 3,
			img: imgclothes.male_oxxo_shirt,
		},
	],
	pants: [
		{
			id: 4,
			img: imgclothes.male_beruda_short,
		},
		{
			id: 5,
			img: imgclothes.male_pants,
		},
		{
			id: 6,
			img: imgclothes.male_shorts,
		},
	],
	shoes: [
		{
			id: 7,
			img: imgclothes.male_shoes,
		},
		{
			id: 8,
			img: imgclothes.male_flip_flops,
		},
		{
			id: 9,
			img: imgclothes.male_sandals,
		},
	],
};
const femaleClothes = {
	shirt: [
		{
			id: 1,
			img: imgclothes.female_top,
		},
		{
			id: 2,
			img: imgclothes.female_shirt,
		},
		{
			id: 3,
			img: imgclothes.female_oxxo_shirt,
		},
	],
	pants: [
		{
			id: 4,
			img: imgclothes.female_short,
		},
		{
			id: 5,
			img: imgclothes.female_pants,
		},
		{
			id: 6,
			img: imgclothes.female_skirt,
		},
	],
	shoes: [
		{
			id: 7,
			img: imgclothes.female_shoes,
		},
		{
			id: 8,
			img: imgclothes.female_heels,
		},
		{
			id: 9,
			img: imgclothes.female_sandals,
		},
	],
};

const GridClothes = ({ clothes, selecClotheShirt, selecClothepants, selecClotheshoes, shirtSelected, pantsSelected, shoesSelected }) => {
	// Agregar la propiedad 'type' a cada objeto en los arrays originales
	const withType = Object.entries(clothes).map(([type, items]) => {
		return items.map(item => ({ ...item, type }));
	});

	// Combinar los arrays con la propiedad 'type' en un solo array
	const combinedArray = withType.flat();
	const clothType = {
		shirt: 0,
		pants: 1,
		shoes: 2,
	}
	return (
		<>
			{combinedArray.map((cloth, index) => {
				let styleJson = {
					borderSelect: ""
				}
				if (clothType.shirt === clothType[cloth.type] && shirtSelected.id === cloth.id) {
					styleJson = {
						borderSelect: "border-[#ffc427] border-4"
					}
				} else if (clothType.pants === clothType[cloth.type] && pantsSelected.id === cloth.id) {
					styleJson = {
						borderSelect: "border-[#ffc427] border-4"
					}

				} else if (clothType.shoes === clothType[cloth.type] && shoesSelected.id === cloth.id) {
					styleJson = {
						borderSelect: "border-[#ffc427] border-4"
					}
				}
				return (
					<div key={`${index}-cloths`} className={`w-full h-full overflow-hidden bg-[#d9d9d9] rounded-lg`}>
						<div onClick={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoRespuesta)
							if (clothType.shirt === clothType[cloth.type]) {
								selecClotheShirt(cloth);
							} else if (clothType.pants === clothType[cloth.type]) {
								selecClothepants(cloth);
							} else if (clothType.shoes === clothType[cloth.type]) {
								selecClotheshoes(cloth);
							}
						}} className={`h-full w-full ${styleJson.borderSelect}`}>
							<img className="h-full w-full object-contain" src={cloth.img} alt="cloth-img" />
						</div>
					</div>
				)
			})}
		</>
	);
};

export const SubtopicOneActivityOne = () => {
	const dispatch = useDispatch();
	const navigator = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [generoSelected, setGeneroSelected] = useState(true);
	const [uitoShow, setUitoShow] = useState(steps.initialDialog);

	const [shirtSelected, setShirtSelected] = useState({});
	const [pantsSelected, setPantsSelected] = useState({});
	const [shoesSelected, setShoessSelected] = useState({});

	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema1], 1);

	useEffect(() => {
		if (loaded) {
			console.log("subtema one Activity one");
			ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act1_a01)
	})

	const selecClotheShirt = (selected) => {
		ObserverEmitter.emit(EVENTS.subtopicOne.activityOne.upChangeClothe, selected.id);
		setShirtSelected(selected);
	};
	const selecClothepants = (selected) => {
		ObserverEmitter.emit(EVENTS.subtopicOne.activityOne.middleChangeClothe, selected.id);
		setPantsSelected(selected);
	};
	const selecClotheshoes = (selected) => {
		ObserverEmitter.emit(EVENTS.subtopicOne.activityOne.botoomChangeClothe, selected.id);
		setShoessSelected(selected);
	};

	const defaultSelecteds = () => {
		ObserverEmitter.emit(EVENTS.subtopicOne.activityOne.onHiddenAllClothes);
		setShirtSelected({});
		setPantsSelected({});
		setShoessSelected({});
	};

	const verifyActivityCompleted = () => {
		if (shirtSelected.id && shoesSelected.id && pantsSelected.id) {
			// * valuacion para ver si gano
			if (shirtSelected.id === 3 && pantsSelected.id === 5 && shoesSelected.id === 7) {
				setUitoShow(steps.win);
				ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
				ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
				dispatch(
					completeOneTask({
						idActivity: 1,
						pointsWin: 10,
						subtema: tasksId.tema1.activities.subtema1,
					})
				);
			} else {
				defaultSelecteds();
				ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
				setUitoShow(steps.fail);
			}
		}
	};

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{uitoShow !== 1 && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 1);
						setUitoShow(1)
					}} />
				)}
			</>
			{uitoShow === steps.initialDialog && (
				<>
					<HeaderRedPresentation name="Actividad 1: Código de vestimenta." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`¡Muy bien! Comenzaremos con nuestra primera actividad: “Codigo de vestimenta”. Acomoda la ropa del ayudante en tienda de acuerdo al código de vestimenta de OXXO.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUitoShow(steps.instructions);
						}}
						percentage={"50%"}
					></DialogBarNew>
				</>
			)}
			{uitoShow === steps.instructions && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Imagen en la tienda."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.subtopicOne.activityOne.visibleCharacterDress);
							ObserverEmitter.emit(EVENTS.subtopicOne.activityOne.moveCamareToCharacterDress);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act1_a02)
							setUitoShow(steps.instructionsDialog);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uitoShow >= 3 && (
				<>
					<BarStatusActivies styleExtra="left-[30%] -translate-x-[30%]" activities={tasksList} />
					<DialogBarCharacterDress
						titulo="Datti Andatti"
						dialog={dialogues.dialogTwo}
						percentage={"99%"}
						isVisibleButton={false}
						genere={generoSelected}
						actionChange={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.navigationInfo)
							if (generoSelected) {
								ObserverEmitter.emit(EVENTS.subtopicOne.activityOne.changeGenere, false);
								defaultSelecteds();
								setGeneroSelected(false);
							} else {
								ObserverEmitter.emit(EVENTS.subtopicOne.activityOne.changeGenere, true);
								defaultSelecteds();
								setGeneroSelected(true);
							}
						}}
					>
						{/* md:w-[72px] w-[40px] */}
						<div className="bg-[#043072] h-full w-full py-2 px-4">
							<div className="h-[88px] md:h-[150px] w-full flex flex-col justify-center gap-1 md:gap-3">
								<div className="bg-red_primary rounded-xl border-[1px] w-full flex justify-center items-center py-1 border-white">
									<span className="text-white text-[10px] md:text-[16px] text-center">Proporciona el uniforme al empleado.</span>
								</div>
								<div className="bg-[#FFC427] py-1 px-2 rounded-xl flex justify-center items-center border-[1px] border-white">
									<span className="text-black text-[8px] md:text-[14px] text-center">
										Es importante que conozcas el código de vestimenta de OXXO ahora que estás comenzando con tu capacitación.
									</span>
								</div>
							</div>
							<div className="h-[calc(100%-88px-40px)] md:h-[calc(100%-150px-80px)] w-full overflow-hidden grid grid-cols-3 gap-2 px-7 py-2 md:py-[45px]">
								{generoSelected ? (
									<GridClothes
										pantsSelected={pantsSelected}
										shirtSelected={shirtSelected}
										shoesSelected={shoesSelected}
										selecClotheShirt={selecClotheShirt}
										selecClothepants={selecClothepants}
										selecClotheshoes={selecClotheshoes}
										clothes={clothes}
									></GridClothes>
								) : (
									<GridClothes
										pantsSelected={pantsSelected}
										shirtSelected={shirtSelected}
										shoesSelected={shoesSelected}
										selecClotheShirt={selecClotheShirt}
										selecClothepants={selecClothepants}
										selecClotheshoes={selecClotheshoes}
										clothes={femaleClothes}
									></GridClothes>
								)}
							</div>
							<div className="h-[40px] md:h-[80px] w-full md:py-4 md:px-[70px]">
								<button
									onClick={() => {
										ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
										verifyActivityCompleted();
									}}
									className="boxShadowButtons bg-[#FFC427] h-full w-full text-white text-[16px] md:text-xl font-semibold rounded-xl py-1.5"
								>
									Validar respuesta
								</button>
							</div>
						</div>
					</DialogBarCharacterDress>
				</>
			)}

			{uitoShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="Un colaborador con buena higiene representa una buena imagen a la tienda."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							navigator("/home1/tema1/subtema1/activitytwo");
						}}
					/>
				</>
			)}

			{uitoShow === steps.fail && (
				<ValidationResultModal
					title="¡Respuesta incorrecta!"
					dialogModal="Recuerda que la vestimenta es clave dentro de la tienda, debemos tenerla alineada a las normas."
					buttonTxt="Continuar"
					isCorrect={false}
					action={() => {
						navigator("/home1/tema1/subtema1/activitytwo");
					}}
				/>
			)}
		</>
	);
};
